/**
 * The metrics to use when reporting activities.
 */
export const METRICS = {
    ACTIVITY: 'activity',
    BUSINESS: 'business'
};

/**
 * The possible error messages.
 */
export const ERRORS = {
    REPORT_ACTIVITY_SERVER_FAILED: 'Report activity failed on server',
    REPORT_ACTIVITY_CLIENT_FAILED: 'Report activity failed on client'
};
